import * as React from "react";

const FRFlag = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={25}
		height={16}
		viewBox="0 0 25 16"
		{...props}
	>
		<path width={900} height={600} fill="#ED2939" d="M0 0H25V16.666H0V0z" />
		<path width={600} height={600} fill="#fff" d="M0 0H16.666V16.666H0V0z" />
		<path width={300} height={600} fill="#002395" d="M0 0H8.334V16.666H0V0z" />
	</svg>
);

export default FRFlag;